<template>
  <div class="jmk-home literature-home">
    <sbanner></sbanner>

    <div class="container">
      <sub-cate :cateList="colums" @clickChange="changeCate" v-if="colums && colums.length"></sub-cate>

      <template v-for="(item, index) in colums">
        <Item :key="index" :row="item" :colums="colums" />
      </template>
    </div>
  </div>
</template>

<script>
import sbanner from '@/components/sbanner.vue'
import colums from '@/colums/colums.js'  //展品库的分类名称
import SubCate from '@/components/sub-cate.vue'
import Item from './components/Item.vue'
export default {
  components: { sbanner, SubCate, Item },
  name: 'literature',
  props: {},
  data() {
    return {
      colums: []
    }
  },
  mounted() {
    this.getSubCates()
  },
  methods: {
    async getSubCates() {
      const cate = colums.literatureCate || []
      try {
        const res = await this.$api.literatureApi.getCateList()
        cate.forEach((v, i) => {
          const list = res[`data${i + 1}`]
          if (list && list.length) {
            v.children = list
          }
        })
      } catch (error) {

      }
      this.colums = cate
      this.$api.recordApi.addListRecord('文学');
    },
    changeCate({ id }) {
      if (id) {
        this.$router.push({
          path: '/literature',
          query: {
            cate: id
          }
        })
      }
    },
  },
}
</script>
<style scoped lang="scss"></style>